import axiosInstance from "../../axiosInstance";
import qs from "qs";


export const fetchSpeakerBySpeakerId = async (speakerId) => {
  try {
    const response = await axiosInstance.get(`/api/v1/speakers/${speakerId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching speaker with speakerId ${speakerId}:`, error);
    throw error;
  }
};


export const fetchSpeakersByUsers = async ({
  IndustryIds = [],
  SpecialitiesId = [],
  CountryIds = [],
  StateId = '',
  CityId = '',
  OrderBy = '',
  Keyword = '',
  Page = 1,
  PageCount = 1000
}) => {
  try {    
    const response = await axiosInstance.get('/api/v1/users/speakers', {
      params: {
        IndustryIds,
        SpecialitiesId,
        CountryIds,
        StateId,
        CityId,
        OrderBy,
        Keyword,
        Page,
        PageCount,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching speakers:', error);
    throw error;
  }
};

// دالة لجلب متحدث بناءً على الـ userId
export const fetchSpeakerByIdByUsers = async (userId) => {
  try {
    const response = await axiosInstance.get(
      `/api/v1/users/speakers/${userId}`
    );
    return response.data; // البيانات التي تم جلبها
  } catch (error) {
    console.error(`Error fetching speaker with id ${userId}:`, error);
    throw error;
  }
};

// لجلب كتب الاسيبكرز للزوار
export const fetchBooksByUsers = async (params) => {
  try {
    const response = await axiosInstance.get("api/v1/users/speakers/books", {
      params: {
        userId: params?.userId,
        page: params?.page || 1,
        pageSize: params?.pageSize || 10,
      }
    });

    return response.data;
  } catch (error) {
    console.error("خطأ في جلب الكتب:", error);
    throw error;
  }
};

// دالة لقراءة جميع المشاركات/المساهمات
export const getContributionsByUsers = async (
  userId,
  page = 1,
  pageSize = 10
) => {
  try {
    // تعديل المسار والمعلمات لتتوافق مع باقي الـ API
    const response = await axiosInstance.get(
      "/api/v1/users/speakers/contributions",
      {
        params: {
          userId,
          Page: page,
          PageCount: pageSize,
        }
      }
    );

    return response;
  } catch (error) {
    console.error("Error in getContributions:", error);
    throw error;
  }
};

// دالة لقراءة تفاصيل مساهمة واحدة
export const getContributionByIdByUsers = async (contributionId) => {
  try {
    const response = await axiosInstance.get(`/api/v1/users/speakers/contributions/${contributionId}` );
    return response.data;
  } catch (error) {
    console.error("Error retrieving contribution:", error);
    throw error;
  }
};

// دالة لجلب قائمة الفيديوهات
export const getVideosByUsers = async (params) => {
  try {
    const response = await axiosInstance.get("/api/v1/users/speakers/videos", {
      params: {
        userId: params.userId,
        Page: params.page,
        PageCount: params.pageCount,
      }
    });
    return response;
  } catch (error) {
    console.error("Error retrieving videos:", error);
    throw error;
  }
};

// دالة لقراءة فيديو محدد
export const getVideoByIdByUsers = async (videoId, userId) => {
  try {
    const response = await axiosInstance.get(
      `/api/v1/users/speakers/videos/${videoId}`,
      {
        params: {
          userId,
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error retrieving video:", error);
    throw error;
  }
};

export const getArticleByIdByUsers = async (articleId) => {
  try {
    const response = await axiosInstance.get(`/api/v1/users/articles/${articleId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching article:", error);
    throw error;
  }
};

// دالة لجلب قائمة المقالات
export const getArticlesByUsers = async (params) => {
  try {
    const response = await axiosInstance.get("/api/v1/users/articles", {
      params: {
        UserId: params.UserId,
        Page: params.Page,
        PageCount: params.PageCount,
      }
    });
    return response;
  } catch (error) {
    console.error("Error in getArticles:", error);
    throw error;
  }
};
